<input type="text" [value]="calculatedMath === undefined ? ' - ' : calculatedMath" disabled/>
